import {
  getPostApiV1ThreeLetterCodePartnerAdminsTopBannersMutationFetcher,
  getPostApiV1ThreeLetterCodePartnerAdminsTopBannersMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { PostApiV1ThreeLetterCodePartnerAdminsTopBannersBody } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';

/**
 * トップバナー作成APIを実行するカスタムフック
 *
 * @param threeLetterCode - パートナーコード
 * @param options - コールバックオプション
 * @param options.onSuccess - 成功時のコールバック
 * @param options.onError - エラー時のコールバック
 */
export const usePostPartnerAdminsTopBanners = (
  threeLetterCode: string,
  options?: {
    onSuccess?: (data: PostApiV1ThreeLetterCodePartnerAdminsTopBannersBody) => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getPostApiV1ThreeLetterCodePartnerAdminsTopBannersMutationKey(threeLetterCode),
    getPostApiV1ThreeLetterCodePartnerAdminsTopBannersMutationFetcher(threeLetterCode),
    options
  );
};
